import { j as r } from "../../../../_virtual/jsx-runtime.js";
import i from "../../NotificationTooltip/index.js";
const n = ({
  active: l,
  payload: o,
  activeBar: t,
  tooltipContent: e
}) => l && o && o.length && t ? /* @__PURE__ */ r.jsx(
  "div",
  {
    className: "tooltip-wrapper absolute",
    style: {
      left: `${t.x}px`,
      top: `${t.y - 16}px`
    },
    children: /* @__PURE__ */ r.jsx(i, { children: e })
  },
  t.index
) : null;
export {
  n as default
};
